module.exports = __webpack_public_path__ + "assets/img/501.2b7ce225.png";